import axios from 'axios';

export function isDealEmailEnabled(organization) {
  return (
    Boolean(organization?.slug) &&
    organization?.crm_settings?.deal_email_enabled === true
  );
}

export const dealEmailService = {
  async getInbox(tab = 'needs_reply') {
    const response = await axios.get('/emails/inbox', { params: { tab } });
    return response.data;
  },

  async getInboxCounts() {
    const response = await axios.get('/emails/inbox/counts');
    return response.data;
  },

  async getDealEmails(dealId) {
    const response = await axios.get(`/deals/${dealId}/emails`);
    return response.data;
  },

  async sendDealEmail(dealId, { subject, body, recipients }) {
    const response = await axios.post(`/deals/${dealId}/emails`, {
      subject,
      body,
      recipients,
    });
    return response.data;
  },

  async replyOnThread(threadId, { body, subject }) {
    const response = await axios.post(`/emails/${threadId}/reply`, { body, subject });
    return response.data;
  },

  async linkThreadToDeal(threadId, dealId) {
    const response = await axios.post(`/emails/${threadId}/link-deal`, { deal_id: dealId });
    return response.data;
  },
};

export default dealEmailService;
